import { LegalPage, LegalSection } from "@/components/site/LegalPage";

export default function Disclaimer() {
  return (
    <LegalPage title="Terms of Use & Disclaimer" updated="31 August 2026" testId="disclaimer-page">
      <LegalSection title="Welcome">
        <p>
          Welcome to Globus Financial Services. By accessing or using this website, submitting an enquiry, or
          communicating with us, you agree to these Terms of Use and Disclaimer.
        </p>
      </LegalSection>

      <LegalSection title="1. About our services">
        <p>
          Globus Financial Services provides loan-advisory and loan-sourcing support for corporate, MSME and
          individual borrowing requirements, including term loans, working capital facilities, business loans,
          loan against property, home loans and invoice discounting.
        </p>
        <p>
          We assist clients with understanding their borrowing requirement, preparing and organising documentation,
          and introducing suitable cases to banks, NBFCs and other lending institutions, where appropriate.
        </p>
        <p>
          Globus Financial Services is not a bank or NBFC and does not itself lend money, accept deposits, collect
          repayments, or issue loan approvals. All credit appraisal, sanction, disbursal, pricing, interest rate,
          fees, security requirements and other loan terms are decided solely by the relevant lender.
        </p>
      </LegalSection>

      <LegalSection title="2. No investment or securities advice">
        <p>
          This website and our communications are for general information regarding borrowing and lending solutions
          only. Globus Financial Services does not provide investment advice, securities advice, stock-market or
          trading recommendations, portfolio-management services, wealth-management services, mutual-fund advice,
          or guaranteed-return products.
        </p>
        <p>
          Nothing on this website is an offer, recommendation or solicitation to buy or sell securities or
          investment products.
        </p>
      </LegalSection>

      <LegalSection title="3. No guarantee of loan approval">
        <p>
          Submitting an enquiry or sharing documents does not assure eligibility, loan approval, sanction,
          disbursal, a particular interest rate, amount, tenure or turnaround time. The final decision rests solely
          with the lender and is subject to its policies, credit assessment, verification, documentation and
          applicable law.
        </p>
      </LegalSection>

      <LegalSection title="4. Client information and documents">
        <p>
          You confirm that information and documents shared with us are accurate, complete and authorised to be
          shared. You authorise us to use and share relevant information and documents with potential lenders or
          service partners only to assess and process your stated borrowing requirement, subject to our Privacy
          Policy and applicable law.
        </p>
        <p>
          Please do not share OTPs, card PINs, internet-banking passwords or other sensitive credentials with us.
          A legitimate loan process should not require such information.
        </p>
      </LegalSection>

      <LegalSection title="5. Fees and third-party charges">
        <p>
          Any professional fee, advisory fee or success fee payable to Globus Financial Services, if applicable,
          will be communicated separately and agreed in writing. Lenders may independently charge processing fees,
          legal fees, valuation fees, insurance premiums, foreclosure charges or other applicable charges. Please
          review the lender's official sanction letter and loan documents carefully before accepting any facility.
        </p>
      </LegalSection>

      <LegalSection title="6. Website information">
        <p>
          We aim to keep the website information accurate and current; however, lender policies, eligibility
          criteria, rates, product availability and regulations may change without notice. Information on this
          website is not a substitute for the lender's official terms or independent professional advice.
        </p>
      </LegalSection>

      <LegalSection title="7. Third-party links and lenders">
        <p>
          The website may refer to or link to third-party lenders, platforms or service providers. Globus
          Financial Services does not control their websites, products, decisions, practices or content. Your
          dealings with a lender or third party are governed by that party's terms and privacy policy.
        </p>
      </LegalSection>

      <LegalSection title="8. Limitation of liability">
        <p>
          To the extent permitted by law, Globus Financial Services is not liable for a lender's credit decision,
          delay, rejection, change in terms, technical failure, third-party action, or loss arising from reliance
          on general information published on this website.
        </p>
      </LegalSection>

      <LegalSection title="9. Governing law">
        <p>
          These Terms are governed by the laws of India. Courts in Delhi NCR shall have jurisdiction over disputes
          arising from use of this website, subject to applicable law.
        </p>
      </LegalSection>

      <LegalSection title="10. Contact us">
        <p>For questions about these Terms or our services, please contact:</p>
        <p>
          Globus Financial Services<br />
          HC-3, 3rd Floor, Durga Apartment<br />
          761 Shalimar Garden Ext-1, Sahibabad<br />
          Ghaziabad, Uttar Pradesh-201005
          Website: globusfinancialservices-in.com<br />
          WhatsApp: +91 87965 12777
        </p>
      </LegalSection>
    </LegalPage>
  );
}
